import { useState } from 'react';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestArticles() {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const [visibleCount, setVisibleCount] = useState(6);

  const filtered = activeCategory === 'all'
    ? articles
    : articles.filter((a) => a.categorySlug === activeCategory);

  const displayed = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          最新文章
        </h2>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => { setActiveCategory('all'); setVisibleCount(6); }}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors duration-200 whitespace-nowrap ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => { setActiveCategory(cat.slug); setVisibleCount(6); }}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors duration-200 whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
        {displayed.map((article) => (
          <ArticleCard key={article.slug} {...article} isFeatured={false} />
        ))}
      </div>
      {hasMore && (
        <div className="mt-8 text-center">
          <button
            onClick={() => setVisibleCount((prev) => prev + 6)}
            className="px-8 py-3 bg-background-100 text-foreground-700 rounded-full font-medium text-sm hover:bg-background-200 transition-colors duration-200 whitespace-nowrap"
          >
            加载更多文章
            <i className="ri-arrow-down-line ml-2"></i>
          </button>
        </div>
      )}
    </section>
  );
}